import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Row, Col, AutoComplete, Input, Icon } from 'antd';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import Enums from 'utils/EnumsManager';
import { toggleRightSider } from 'components/page/RightSider/flow/action';
import { setWidth } from 'components/page/EnhancedSider/flow/actions';
import ActionFilter from '../CommonComponents/ActionFilter';
import {
  setTriggerObject,
  fetchFieldsByType,
  addTriggerAction,
  updateTriggerActionFilterValue,
  removeSessionFilter,
  resetSiderData,
  setSiderData,
  fetchRightSideData,
} from '../../flow/action';
import { formatSiderOptions } from '../../utils/criterialUtils';
import styles from '../../index.less';

const defaultProps = {
  objectOptions: [],
  actionFilters: {},
  metaFieldsData: {},
};
const propTypes = {
  actionValue: PropTypes.object.isRequired,
  hadleSiderClose: PropTypes.func.isRequired,
  objectOptions: PropTypes.array,
  metaFieldsData: PropTypes.object,
  actionFilters: PropTypes.object,
  collapsed: PropTypes.bool.isRequired,
  dispatchSetTriggerObject: PropTypes.func.isRequired,
  dispatchFetchFieldsByType: PropTypes.func.isRequired,
  dispatchAddTriggerAction: PropTypes.func.isRequired,
  dispatchUpdateTriggerActionFilterValue: PropTypes.func.isRequired,
  dispatchRemoveSessionFilter: PropTypes.func.isRequired,
  dispatchToggleRightSider: PropTypes.func.isRequired,
  dispatchSetWidth: PropTypes.func.isRequired,
  dispatchFetchRightSideData: PropTypes.func.isRequired,
  dispatchSetSiderData: PropTypes.func.isRequired,
  dispatchResetSiderData: PropTypes.func.isRequired,
};

const cx = classNames.bind(styles);
const AutoOption = AutoComplete.Option;

const { FieldTypes, WorkFlow } = Enums;
const { Lookup, PickList } = FieldTypes;
const { UserInput, ActionValueType } = WorkFlow;
const {
  FILTERVALUE,
  FIELDID,
  FUNCTIONTYPE,
  DISTRIBUTIONVALUE
} = ActionValueType;

class UpdateFieldsContent extends React.Component {
  componentDidMount() {
    const { actionValue } = this.props;
    const { triggerValue } = actionValue;
    if (!_.isEmpty(triggerValue) && triggerValue.objectKey) {
      this.fetchMetaFields(triggerValue.objectKey);
    }
  }

  getSlelectedObjectType = () => {
    const { objectOptions, actionValue } = this.props;
    const { triggerValue } = actionValue;
    return objectOptions.find(object => object.object_key === triggerValue.objectKey);
  }

  fetchMetaFields = value => {
    const {
      dispatchFetchFieldsByType,
      metaFieldsData,
      objectOptions
    } = this.props;
    const selectedObject = objectOptions.find(object => object.object_key === value);
    const selectedObjectType = selectedObject ? selectedObject.object_type : '';
    if (_.isEmpty(metaFieldsData[selectedObjectType])) {
      dispatchFetchFieldsByType(selectedObjectType);
    }
  }

  handleObjectChange = value => {
    const {
      actionValue,
      dispatchSetTriggerObject,
    } = this.props;
    const { sessionNum } = actionValue;
    dispatchSetTriggerObject(sessionNum, value);
    this.fetchMetaFields(value);
  };

  hadleFilterValueChange = (sessionNum, displayNum, updateValue, updateKey) => {
    const { dispatchUpdateTriggerActionFilterValue, collapsed, hadleSiderClose } = this.props;
    dispatchUpdateTriggerActionFilterValue(sessionNum, displayNum, updateValue, updateKey);
    // Reset other Column while the current Column has changed.
    switch (updateKey) {
      case FIELDID:
        dispatchUpdateTriggerActionFilterValue(sessionNum, displayNum, UserInput, FUNCTIONTYPE);
        dispatchUpdateTriggerActionFilterValue(sessionNum, displayNum, '', FILTERVALUE);
        break;
      case FUNCTIONTYPE:
        dispatchUpdateTriggerActionFilterValue(sessionNum, displayNum, '', FILTERVALUE);
        break;
      case FILTERVALUE:
      case DISTRIBUTIONVALUE:
        break;
      default:
        console.log(updateKey, 'No such key');
        break;
    }
    if (collapsed || updateKey === FILTERVALUE) return;
    hadleSiderClose();
  };

  handleAddonClick = filter => {
    const {
      metaFieldsData,
      collapsed,
      actionValue,
      dispatchToggleRightSider,
      dispatchSetWidth,
      dispatchSetSiderData,
      dispatchFetchRightSideData,
      dispatchResetSiderData
    } = this.props;
    const { sessionNum } = actionValue;
    const selectedObjectType = this.getSlelectedObjectType();
    if (_.isEmpty(selectedObjectType) || !selectedObjectType.object_type) return;
    dispatchResetSiderData();
    const selectedField = metaFieldsData[selectedObjectType.object_type].find(data => data.field_name === filter.fieldId);
    const parseFilter = {
      ...filter,
      type: selectedField.crm_data_type
    };
    if (selectedField.crm_data_type === Lookup) {
      dispatchFetchRightSideData(`/admin/objects/lookup-metadata/${selectedField.id}`, parseFilter, sessionNum);
    }
    if (selectedField.crm_data_type === PickList) {
      const options = formatSiderOptions(selectedField.picklists, selectedField.crm_data_type);
      dispatchSetSiderData(options, parseFilter, sessionNum);
    }
    if (!collapsed) return;
    dispatchSetWidth('right', 300);
    dispatchToggleRightSider(false);
  }

  render() {
    const {
      objectOptions,
      actionValue,
      metaFieldsData,
      actionFilters,
      dispatchAddTriggerAction,
      dispatchRemoveSessionFilter
    } = this.props;
    const { triggerValue, sessionNum } = actionValue;
    const selectedObjectType = this.getSlelectedObjectType();

    const renderAutoCompleteOption = item => (
      <AutoOption
        key={item.object_key}
        value={item.object_key}
        onChange={this.handleObjectChange}
      >
        {item.name}
      </AutoOption>
    );

    const filterAutoOption = (inputValue, option) => option.props.children.toLowerCase().trim().indexOf(inputValue.toLowerCase().trim()) > -1;

    return (
      <React.Fragment>
        <Row gutter={8}>
          <Col span={1} className={classNames(cx('workFlow-form-label'), cx('action-label'), 'text-right')}>
            <FormattedMessage id="page.WorkFlow.object" />
          </Col>
          <Col span={8}>
            <AutoComplete
              className="full-width"
              defaultValue={triggerValue.objectKey ? triggerValue.objectKey.toString() : ''}
              dataSource={objectOptions.map(renderAutoCompleteOption)}
              filterOption={filterAutoOption}
              onSelect={this.handleObjectChange}
            >
              <Input suffix={<Icon type="search" />} />
            </AutoComplete>
          </Col>
        </Row>
        <Row gutter={8}>
          <Col span={1} className={classNames(cx('workFlow-form-label'), 'text-right')}>
            <FormattedMessage id="page.WorkFlow.actions" />
          </Col>
        </Row>
        {selectedObjectType && selectedObjectType.object_type &&
          <Row>
            <ActionFilter
              fieldsOptions={metaFieldsData[selectedObjectType.object_type]}
              sessionNum={sessionNum}
              actionFilters={actionFilters[sessionNum]}
              addTriggerAction={dispatchAddTriggerAction}
              handleValueChange={this.hadleFilterValueChange}
              removeSessionFilter={dispatchRemoveSessionFilter}
              handleAddonClick={this.handleAddonClick}
            />
          </Row>
        }
      </React.Fragment>
    );
  }
}

UpdateFieldsContent.defaultProps = defaultProps;
UpdateFieldsContent.propTypes = propTypes;

const mapStateToProps = ({ global, setup, ui }) => ({
  lang: global.language,
  objectOptions: setup.workFlow.metaData.triggerMeta.objectOptions,
  metaFieldsData: setup.workFlow.metaData.triggerMeta.fieldsData,
  actionFilters: setup.workFlow.WorkFlowTrigger.actionFilters,
  collapsed: ui.rightSider.collapsed,
});
const mapDispatchToProps = {
  dispatchSetTriggerObject: setTriggerObject,
  dispatchFetchFieldsByType: fetchFieldsByType,
  dispatchAddTriggerAction: addTriggerAction,
  dispatchUpdateTriggerActionFilterValue: updateTriggerActionFilterValue,
  dispatchRemoveSessionFilter: removeSessionFilter,
  dispatchToggleRightSider: toggleRightSider,
  dispatchSetWidth: setWidth,
  dispatchFetchRightSideData: fetchRightSideData,
  dispatchSetSiderData: setSiderData,
  dispatchResetSiderData: resetSiderData
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateFieldsContent);



// WEBPACK FOOTER //
// ./src/views/Setup/WorkFlow/components/TriggerActions/UpdateFieldsContent.jsx